import { render, staticRenderFns } from "./CoreFooter.vue?vue&type=template&id=68d55cac&"
import script from "./CoreFooter.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CoreFooter.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CoreFooter.vue?vue&type=style&index=0&id=68d55cac&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68d55cac')) {
      api.createRecord('68d55cac', component.options)
    } else {
      api.reload('68d55cac', component.options)
    }
    module.hot.accept("./CoreFooter.vue?vue&type=template&id=68d55cac&", function () {
      api.rerender('68d55cac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreFooter/CoreFooter.vue"
export default component.exports